import React from "react";

const Image = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M30.8 7.16H5.2v22.124l14.867-14.687a1.61 1.61 0 0 1 2.263 0l8.47 8.382V7.16ZM2 5.57a1.57 1.57 0 0 1 .468-1.107A1.61 1.61 0 0 1 3.588 4h28.825C33.29 4 34 4.703 34 5.57v25.305a1.57 1.57 0 0 1-.468 1.106 1.61 1.61 0 0 1-1.12.463H3.588c-.42 0-.825-.166-1.122-.46A1.56 1.56 0 0 1 2 30.875V5.57Zm9.6 11.072a3.22 3.22 0 0 1-2.263-.926 3.14 3.14 0 0 1-.937-2.234c0-.839.337-1.643.937-2.235a3.22 3.22 0 0 1 2.263-.926 3.22 3.22 0 0 1 2.263.926c.6.592.937 1.396.937 2.235a3.14 3.14 0 0 1-.937 2.234 3.22 3.22 0 0 1-2.263.926Z"
            fill={fill}
        />
    </svg>
);

export default Image;